<template>
    <colored-letter-square
        :name="data.name"
        :length="2"
        :color="color"
    ></colored-letter-square>
</template>

<script>
    export default {
        props: ['data', 'filter'],

        computed: {
            color() {
                switch (this.status) {
                    case 'completed':
                        return '#57ab27';
                    case 'overdue':
                        return '#d65c5c';
                    default:
                        return '#f19933';
                }
            },

            status() {
                const {data, filter} = this;

                // If there is a course filter, show only the filtered course status
                if (filter.filterByCourse) {
                    const filteredCourse = data.assignments.find(({course_id}) => course_id === filter.filterByCourse.id);
                    return filteredCourse ? filteredCourse.status : data.status;
                }

                return data.status;
            }
        },
    }
</script>
